import type {
  TableColumnType,
  TableDataType,
} from '@data/components/basic/Table/types';
import { formatAssessmentDate } from './format-assessment-date';

const EM_DASH = '—';

export function formatTableData(
  value: TableDataType,
  type: TableColumnType,
  csv = false
): string {
  if (value == null) {
    return csv ? '' : EM_DASH;
  }

  switch (type) {
    case 'date':
      return formatAssessmentDate(String(value));

    case 'string':
    case 'id':
    case 'object':
    case 'user':
      return String(value);

    case 'integer':
    case 'long': {
      const n = Number(value);
      if (!Number.isFinite(n)) {
        return String(value);
      }
      return Math.trunc(n).toLocaleString();
    }

    case 'double':
    case 'decimal': {
      const n = Number(value);
      if (!Number.isFinite(n)) {
        return String(value);
      }
      return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }

    case 'percent': {
      const n = Number(value);
      if (!Number.isFinite(n)) {
        return String(value);
      }
      return `${(n * 100).toLocaleString(undefined, {
        maximumFractionDigits: 0,
      })}%`;
    }

    case 'group':
      return '';

    default:
      return String(value);
  }
}
